// eslint-disable-line no-unused-expressions

import { divide } from "lodash";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as retargetEvents from "react-shadow-dom-retarget-events";
import BitreelViewerComponent from "./AppMain";
import QRpopup from "./UI/QRpopup/QRpopup";
import { debugMessage, getMobileOperatingSystem } from "./utils/utils";
import { loadCSS } from "fg-loadcss";

const JSFILES = [
  {
    url: "https://cdn.8thwall.com/web/xrextras/xrextras.js",
    type: "js",
  },
  {
    url:
      "//apps.8thwall.com/xrweb?appKey=tVhJEX5P8xis5LnVJADk9F8ok2tAr9wyAPvEcbTOYnUWtHctCXzd8kwl2KDtmGasHsiNdX",
    type: "js",
  },
];

const CSSFILES = [
  {
    url: `https://bitreel-viewer-scripts.s3.amazonaws.com/bitreel-styles${
      process.env.REACT_APP_DEV_BUILD ? "-dev" : ""
    }.css`,
    type: "css",
  },
  {
    url:
      "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css",
    type: "css",
  },
];

const template = document.createElement("template");
template.innerHTML = `<slot></slot>`;

let bitreelFilesRemaining = 0; // set below
let stylesNodes = [];
let launched = false;

export default class BitreelViewer extends HTMLElement {
  createViewer = (storeName, showroomName, customElement) => {
    this.reactComponent = React.createElement(BitreelViewerComponent, {
      showroomName,
      storeName,
      customElement,
    });
    return this.reactComponent;
  };

  launchQRCode = () => {
    console.log("launch QR code");
    let mountPoint = document.createElement("div");
    document.body.appendChild(mountPoint);
    const storeName = this.getAttribute("storename");
    const showroomName = this.getAttribute("showroom");
    this.reactComponent = React.createElement(QRpopup, {
      showroomName,
      storeName,
      customElement: this,
    });
    ReactDOM.render(this.reactComponent, mountPoint);
  };

  removeStyles = () => {
    stylesNodes.forEach((node) => {
      document.body.removeChild(node);
    });
  };

  // this is only for qr code for now
  unmountReactComonent = () => {
    this.removeStyles();
    ReactDOM.unmountComponentAtNode(this.reactComponent);
    this.reactComponent = null;
  };

  embedViewerFiles = (files, reload) => {
    // TODO: show a loading spinner
    bitreelFilesRemaining = files.length;
    return new Promise(async (resolve, reject) => {
      files.forEach(({ url, type }) => {
        debugMessage("loading file", url);
        switch (type) {
          case "css":
            if (!launched) {
              var stylesheet = loadCSS(url);
              onloadCSS(stylesheet, () => {
                stylesNodes.push(stylesheet);
                this.fileLoaded(resolve, { url, type })();
              });
            } else {
              stylesNodes.forEach((node) => document.body.appendChild(node));
            }
            break;
          case "js":
            let scriptElement = document.createElement("script");
            scriptElement.type = "text/javascript";
            scriptElement.src = url;
            scriptElement.onload = this.fileLoaded(resolve, { url, type });
            document.getElementsByTagName("head")[0].appendChild(scriptElement);
            break;
          default:
            break;
        }
      });
    });
  };

  fileLoaded = (resolve, file) => {
    return () => {
      debugMessage("file loaded", file.url);
      bitreelFilesRemaining = bitreelFilesRemaining - 1;
      if (!bitreelFilesRemaining) {
        setTimeout(() => {
          resolve(true);
        }, 1000);
      }
    };
  };

  async connectedCallback() {
    this.attachShadow({ mode: "open" });

    let viewerCTA = template.content.cloneNode(true);

    this.mountPoint = document.createElement("div");
    this.mountPoint.id = "viewer-mount";

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const launchViewerParam = urlParams.get("launchViewer");

    await this.embedViewerFiles(JSFILES);
    if (launchViewerParam) {
      await this.embedViewerFiles(CSSFILES);
      if (window.navigator.xr) {
        this.makeConfirmModal();
      } else {
        this.launchViewer();
      }
    } else {
      viewerCTA.firstChild.onclick = this.launchViewer;
    }

    this.shadowRoot.appendChild(viewerCTA);
  }

  launchViewer = async () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    const storeName = this.getAttribute("storename");
    const showroomName = this.getAttribute("showroom");

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const launchViewerParam = urlParams.get("launchViewer");

    if (!launchViewerParam) {
      await this.embedViewerFiles(CSSFILES);
    }

    let os = getMobileOperatingSystem();

    if (os === "iOS" || os === "Android") {
      if (window.navigator.xr) {
        this.shadowRoot.appendChild(this.mountPoint);
      } else {
        this.shadowRoot.appendChild(this.mountPoint);
      }

      if (window.navigator.xr) {
        let canvasElement = document.createElement("canvas");
        canvasElement.style.top = 0;
        canvasElement.style.left = 0;
        canvasElement.style.position = "fixed";
        canvasElement.style.height = "100vh";
        canvasElement.style.width = "100vw";
        canvasElement.id = "canvaselement";
        this.shadowRoot.appendChild(canvasElement);

        ReactDOM.render(
          this.createViewer(storeName, showroomName, this),
          this.mountPoint
        );
        retargetEvents(this.shadowRoot);
      } else {
        this.mountPoint.style.position = "fixed";
        this.mountPoint.style.top = "0";
        this.mountPoint.style.left = "0";
        this.mountPoint.style.width = "100vw";
        this.mountPoint.style.height = "100vh";
        this.mountPoint.style.zIndex = "999999999";
        ReactDOM.render(
          this.createViewer(storeName, showroomName, this),
          this.mountPoint
        );
        retargetEvents(this.shadowRoot);
      }
    } else {
      // desktop mode
      this.shadowRoot.appendChild(this.mountPoint);
      this.mountPoint.style.position = "fixed";
      this.mountPoint.style.top = "0";
      this.mountPoint.style.left = "0";
      this.mountPoint.style.width = "100vw";
      this.mountPoint.style.height = "100vh";
      this.mountPoint.style.zIndex = "999999999";
      ReactDOM.render(
        this.createViewer(storeName, showroomName, this),
        this.mountPoint
      );
      retargetEvents(this.shadowRoot);
      //this.launchQRCode();
    }
    launched = true;
  };

  makeConfirmModal = () => {
    let container = document.createElement("div");
    container.style.position = "fixed";
    container.style.width = "100vw";
    container.style.height = "100vh";
    container.style.zIndex = "2000";
    container.style.top = 0;
    container.style.left = 0;
    container.style.backgroundColor = "rgb(0 0 0 / 45%)";
    container.style.display = "flex";
    container.style.alignItems = "center";
    container.style.justifyContent = "center";

    let inner = document.createElement("div");
    inner.style.backgroundColor = "#fff";
    inner.style.borderRadius = "10%";
    inner.style.padding = "20px 10px";

    container.appendChild(inner);

    let button = document.createElement("div");
    button.innerHTML = "Enter Showroom";
    button.style.color = "black";
    button.onclick = () => {
      document.body.removeChild(container);
      this.launchViewer();
    };

    inner.appendChild(button);

    document.body.appendChild(container);
  };
}

const launchIfDev = () => {
  if (process.env.NODE_ENV === "production") {
    window.customElements.define("bitreel-viewer", BitreelViewer);
  } else {
    ReactDOM.render(
      <BitreelViewerComponent />,
      document.getElementById("root")
    );
  }
};

launchIfDev();

/*! onloadCSS. (onload callback for loadCSS) [c]2017 Filament Group, Inc. MIT License */
/* global navigator */
/* exported onloadCSS */
function onloadCSS(ss, callback) {
  var called;
  function newcb() {
    if (!called && callback) {
      called = true;
      callback.call(ss);
    }
  }
  if (ss.addEventListener) {
    ss.addEventListener("load", newcb);
  }
  if (ss.attachEvent) {
    ss.attachEvent("onload", newcb);
  }

  // This code is for browsers that don’t support onload
  // No support for onload (it'll bind but never fire):
  //	* Android 4.3 (Samsung Galaxy S4, Browserstack)
  //	* Android 4.2 Browser (Samsung Galaxy SIII Mini GT-I8200L)
  //	* Android 2.3 (Pantech Burst P9070)

  // Weak inference targets Android < 4.4
  if ("isApplicationInstalled" in navigator && "onloadcssdefined" in ss) {
    ss.onloadcssdefined(newcb);
  }
}
